// Contrato com o IframeTabOpener do shell do GEO (v6): o shell abre e navega a janela pelos
// iframes, porque o painel (Vue) e o Funil (React) sao origens diferentes e o navegador so acha a
// janela pelo nome a partir da origem de quem a abriu. Fora do shell, a janela abre aqui mesmo.
// Espelho de features/crm/sales-funnel/utils/shared-window.ts do geovendas-app.
const windowName = 'janelaCompartilhada';
const handshakeTimeoutMs = 250;

export interface ISharedWindow {
  // false quando o navegador bloqueou a abertura.
  navigate(url: string): boolean;
  // So fecha a janela que ainda esta em branco: a aba ja aberta na EvoTalks e do atendente.
  close(): void;
}

function askShell(): Promise<boolean> {
  return new Promise<boolean>((resolve) => {
    if (window.parent === window) {
      resolve(false);
      return;
    }
    const requestId = `${Date.now()}-${Math.random()}`;
    let timer = 0;
    const onMessage = (event: MessageEvent) => {
      const data = event.data as { action?: string; requestId?: string; opened?: boolean };
      if (event.source !== window.parent || data?.action !== 'sharedWindowOpened' || data.requestId !== requestId) {
        return;
      }
      window.clearTimeout(timer);
      window.removeEventListener('message', onMessage);
      resolve(!!data.opened);
    };
    timer = window.setTimeout(() => {
      window.removeEventListener('message', onMessage);
      resolve(false);
    }, handshakeTimeoutMs);
    window.addEventListener('message', onMessage);
    window.parent.postMessage({ action: 'openSharedWindow', requestId }, '*');
  });
}

function isBlank(target: Window): boolean {
  try {
    return target.location.href === 'about:blank';
  } catch (e) {
    return false;
  }
}

export function openLocalWindow(): ISharedWindow {
  const local = window.open('', windowName);
  return {
    navigate(url: string): boolean {
      if (local && !local.closed) {
        local.location.href = url;
        local.focus();
        return true;
      }
      const reopened = window.open(url, windowName);
      if (reopened) {
        reopened.focus();
      }
      return !!reopened;
    },
    close(): void {
      if (local && !local.closed && isBlank(local)) {
        local.close();
      }
    },
  };
}

// Chamar no gesto do clique: o aperto de mao cabe na janela de ativacao do navegador, um await
// longo antes (sync, envio do template) nao.
export async function openSharedWindow(): Promise<ISharedWindow> {
  if (await askShell()) {
    return {
      navigate(url: string): boolean {
        window.parent.postMessage({ action: 'navigateSharedWindow', url }, '*');
        return true;
      },
      close(): void {
        window.parent.postMessage({ action: 'closeSharedWindow' }, '*');
      },
    };
  }
  return openLocalWindow();
}
